import { container } from '@databases/service-container';

import { DatabasesSmartLinkClient } from '@canvas/smart-link-client/databases';

/**
 * Registers the Databases adapter before application setup can mount React.
 * The singleton is constructed lazily when its first consumer resolves it.
 */
export function registerDatabasesSmartLinkClient(): void {
  container.registerSingleton('SmartLinkClient', () => new DatabasesSmartLinkClient());
}
